import { FormHelperText, InputAdornment, TextField } from "@mui/material";
import * as React from "react";
import { TextInputProps } from "./types";

import "./styles.scss";

const classNameBase = "scd-text-field";

export const TextInput = ({
  disabled,
  label,
  shrink,
  id,
  name,
  placeholder,
  variant = "standard",
  helperText,
  error,
  value,
  type,
  onChange,
  onBlur,
  InputProps,
  helperUnderInput,
  startAdornment,
  endAdornment,
  CustomInputComponent,
}: TextInputProps): React.JSX.Element => {
  const start = startAdornment ? (
    <InputAdornment position="start">{startAdornment}</InputAdornment>
  ) : null;
  const end = endAdornment ? (
    <InputAdornment position="end">{endAdornment}</InputAdornment>
  ) : null;

  let inputProps = {
    classes: {
      root: `${classNameBase}-input-wrapper`,
      input: `${classNameBase}-input${error ? "-error" : ""}`,
    },
    ...InputProps,
    startAdornment: start,
    endAdornment: end,
  };

  if (CustomInputComponent) {
    inputProps = {
      ...inputProps,
      inputComponent: CustomInputComponent,
    };
  }

  return (
    <>
      <div className={`${classNameBase}-container`}>
        <TextField
          disabled={disabled}
          className={`${classNameBase}-wrapper${error ? "-error" : ""}${
            disabled ? "-disabled" : ""
          }`}
          label={label}
          id={id}
          name={name}
          placeholder={placeholder}
          value={value}
          type={type}
          onChange={onChange}
          onBlur={onBlur}
          variant={variant}
          slotProps={{
            input: inputProps,
            inputLabel: {
              classes: {
                root: `${classNameBase}-label`,
                focused: `${classNameBase}-label-focused`,
                disabled: `${classNameBase}-label-disabled`,
                error: `${classNameBase}-label-error`,
                required: `${classNameBase}-label-required`,
                shrink: `${classNameBase}-label-shrinked`,
              },
              shrink: shrink || undefined,
            },
          }}
        />
      </div>
      <>
        {helperUnderInput && !error && (
          <FormHelperText
            className={`${classNameBase}-helper${error ? "-error" : ""}`}
          >
            {helperUnderInput}
          </FormHelperText>
        )}
      </>
      {error && (
        <FormHelperText
          className={`${classNameBase}-helper${error ? "-error" : ""}`}
        >
          {helperText}
        </FormHelperText>
      )}
    </>
  );
};
